module.exports = __webpack_public_path__ + "img/iloilo_c_70121.74e45919.jpg";